import React from 'react';
import type { HtmlFromDotcms } from '../../../dotcms/dotcms-models/converters-from-dotcms';
import HtmlBox from '../../../component_library/components/HtmlBox/HtmlBox';
import Typography, {
  TypographyVariant,
} from '../../../component_library/components/Typography';
import { useGetTheme } from '../../../hooks/use-get-theme';

interface IProps {
  content: HtmlFromDotcms;
}

const Footnote: React.FC<IProps> = ({ content }) => {
  const theme = useGetTheme();

  return (
    <Typography
      variant={TypographyVariant.DISCLAIMER}
      theme={theme}
      color={theme.colors.grayscale.inactiveGrey1}
      additionalStyles={{ a: { color: 'inherit' } }}
    >
      <HtmlBox html={content} />
    </Typography>
  );
};

export default Footnote;
